(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/react/components/start-packages.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/react/components/start-packages.js');

'use strict';

const StartPackages = () => {
  const handleClick = (choice, value) => {
    svs.components.analytics.trackEvent({
      category: 'lotto_startPage',
      action: 'CTA_predefined',
      opt_label: "".concat(choice, "rader"),
      opt_value: value
    }, () => {
      svs.utils.url.navigate("lotto/fardiga-spel/".concat(value));
    });
  };
  return React.createElement("div", {
    className: "start-packages"
  }, React.createElement("div", {
    className: "packages-body"
  }, React.createElement("h2", {
    className: "packages-header"
  }, "Vill du spela f\xE4rdiga spel?"), React.createElement("div", {
    className: "package-wrapper"
  }, React.createElement("div", {
    className: "package",
    onClick: () => handleClick(5, 40)
  }, React.createElement("div", {
    className: "package-rows"
  }, "5 rader"), React.createElement("div", {
    className: "package-price"
  }, "40 kr")), React.createElement("div", {
    className: "package",
    onClick: () => handleClick(15, 100)
  }, React.createElement("div", {
    className: "package-rows"
  }, "15 rader"), React.createElement("div", {
    className: "package-price"
  }, "100 kr")), React.createElement("div", {
    className: "package",
    onClick: () => handleClick(30, 200)
  }, React.createElement("div", {
    className: "package-rows"
  }, "30 rader"), React.createElement("div", {
    className: "package-price"
  }, "200 kr")))));
};
setGlobal('svs.lotto.react.components', {
  StartPackages
});

 })(window);